// extracted by mini-css-extract-plugin
export default {"container":"container-T1U_2RC8","column":"column-SNtY361x"};